import React, { useState, useEffect, useCallback } from "react";
import slide1 from "../assets/hero_slide_1.png";
import slide2 from "../assets/hero_slide_2.png";
import slide3 from "../assets/hero_slide_3.png";

const slides = [
  {
    id: 1,
    bg: slide1,
    tagline: "Welcome to Flakes",
    title: "CRISPY FRIED\nCHICKEN",
    subtitle: "100% HALAL CERTIFIED · FRESHLY PREPARED DAILY",
    cta: "EXPLORE MENU",
    ctaHref: "#menu",
  },
  {
    id: 2,
    bg: slide2,
    tagline: "Our Signature",
    title: "CHICKEN\nBURGERS",
    subtitle: "GOLDEN BRIOCHE BUN · SPECIAL FFC SAUCE · FRESH VEGGIES",
    cta: "ORDER NOW",
    ctaHref: "#order",
  },
  {
    id: 3,
    bg: slide3,
    tagline: "Great Value",
    title: "flakesfriedchicken\nMEALS",
    subtitle: "BEST DEALS IN TOWN · SIDES · DRINKS INCLUDED",
    cta: "SEE flakesfriedchickenS",
    ctaHref: "#menu",
  },
];

const ChevronLeft = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    width="18"
    height="18"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    width="18"
    height="18"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [contentVisible, setContentVisible] = useState(true);

  const goTo = useCallback(
    (index) => {
      if (animating) return;
      setAnimating(true);
      setContentVisible(false);
      setTimeout(() => {
        setCurrent(index);
        setContentVisible(true);
        setAnimating(false);
      }, 400);
    },
    [animating],
  );

  const prev = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length);
  }, [current, goTo]);

  const next = useCallback(() => {
    goTo((current + 1) % slides.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 5500);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="rest-hero" aria-label="Hero Image Slider">
      {/* Background Layers */}
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`rest-hero-bg ${i === current ? "rest-hero-bg--active" : "rest-hero-bg--exit"}`}
          style={{ backgroundImage: `url(${slide.bg})` }}
          aria-hidden="true"
        />
      ))}

      {/* Dark Overlay */}
      <div className="rest-hero-overlay" aria-hidden="true" />

      {/* Slide Content */}
      <div
        className={`rest-hero-content${contentVisible ? "" : " rest-hero-content--hide"}`}
      >
        {/* Tagline (script font) */}
        <p className="rest-hero-tagline">{slides[current].tagline}</p>

        {/* Main Title */}
        <h1 className="rest-hero-title" style={{ whiteSpace: "pre-line" }}>
          {slides[current].title}
        </h1>

        {/* Subtitle */}
        <p className="rest-hero-subtitle">{slides[current].subtitle}</p>

        {/* CTA Button */}
        <a
          href={slides[current].ctaHref}
          className="rest-hero-btn"
          id={`hero-cta-${slides[current].id}`}
        >
          {slides[current].cta}
        </a>
      </div>

      {/* Left Arrow */}
      <button
        className="rest-hero-arrow rest-hero-arrow--left"
        onClick={prev}
        aria-label="Previous slide"
        id="hero-arrow-prev"
      >
        <ChevronLeft />
      </button>

      {/* Right Arrow */}
      <button
        className="rest-hero-arrow rest-hero-arrow--right"
        onClick={next}
        aria-label="Next slide"
        id="hero-arrow-next"
      >
        <ChevronRight />
      </button>

      {/* Dot Indicators */}
      <div
        className="rest-hero-dots"
        role="tablist"
        aria-label="Slide indicators"
      >
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            className={`rest-hero-dot${i === current ? " rest-hero-dot--active" : ""}`}
            onClick={() => goTo(i)}
            role="tab"
            aria-selected={i === current}
            aria-label={`Go to slide ${i + 1}`}
            id={`hero-dot-${i + 1}`}
          />
        ))}
      </div>

      {/* Slide Counter */}
      <div className="rest-hero-counter" aria-live="polite" aria-atomic="true">
        <span className="rest-hero-counter-current">
          {String(current + 1).padStart(2, "0")}
        </span>
        <span className="rest-hero-counter-sep"> / </span>
        <span className="rest-hero-counter-total">
          {String(slides.length).padStart(2, "0")}
        </span>
      </div>

      {/* Scroll Down Indicator */}
      <div className="rest-hero-scroll-hint" aria-hidden="true">
        <div className="rest-hero-scroll-mouse">
          <div className="rest-hero-scroll-wheel" />
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
